/* eslint-disable no-unused-vars */

import React from 'react';
import Text from 'shared/Tipografia/Text';
import Button from 'shared/Button';
import { saveVersion } from 'utils/general';
import { applyServiceWorkerUpdate } from 'serviceWorkerRegistration';
import { Container } from './styles';

interface IUpdateAvailable {
  update: boolean;
  downloadUpdates: boolean;
}

const UpdateAvailable: React.FC<IUpdateAvailable> = ({ update }) => {
  function handleApplyUpdate() {
    saveVersion();
    applyServiceWorkerUpdate();
  }

  return (
    <Container id="containerUpdateAvailable">
      {update && (
        <>
          <Text as="disclaimer">
            Novo conteúdo disponível. Toque para atualizar o aplicativo.
          </Text>
          <Button onClick={() => handleApplyUpdate()}>Atualizar agora</Button>
        </>
      )}
    </Container>
  );
};

export default UpdateAvailable;
